import moment from 'moment';

Vue.component('attendance-show-empty', {
  data: function () {
    return {
        mutableUrl: '',
        selectedMonthMutable: {},
        year: null,
        month: null,
    }
  },

  props: {
    'transMonths': {
      type: Object
    },
    'selectedMonth': {
      type: Object,
      default() {
        return null;
      }
    },
    'baseUrl': {
      type: String
    },
  },

  created() {

    this.year = Number(moment(this.selectedMonth.key).format('YYYY'));
    this.month = Number(moment(this.selectedMonth.key).format('MM'));

    this.selectedMonthMutable = this.selectedMonth.key;
    this.mutableUrl = this.baseUrl;
  },

  methods: {
    chooseMonth(year, month, selectedObj) {
      this.selectedMonthMutable = year + "-" + (month < 10 ? "0" : "") + month;

      this.year = year;
      this.month = month;

      const momentDate = moment(this.selectedMonthMutable, "YYYY-MM");

      this.dateUrlPath = momentDate.format("YYYY/MM");
      this.mutableUrl = (selectedObj ? selectedObj.url : this.baseUrl + "/" + this.dateUrlPath);
      window.location.href = this.mutableUrl;
    },

  }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/attendance/ShowEmpty.js